/**
 * Border Design Tokens
 */

export const borders = {
  radius: {
    xs: '4px',
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
    full: '9999px',
  },
  width: {
    thin: '1px',
    medium: '2px',
    thick: '3px',
  },
  // Icon sizing scale (style guide §7.2)
  iconSize: {
    xs: '14px',
    sm: '16px',
    md: '20px',
    lg: '24px',
    xl: '32px',
    '2xl': '36px',
    '3xl': '44px',
  },
} as const;

export type BorderToken = typeof borders;

